import fvSubassembly from '../fvSubassembly';
export default class fvTextObj extends fvSubassembly {
  constructor(sContent, parent, system, callback) {
    super(sContent, parent, system);
    this.countLen = 0;
    var arr = this.innerText.split(".");
    this.sourceText = this.innerText;
    this.indexText = (this.innerText.split('.')).length - 1;
    this.charText = this.innerText.substr(this.innerText.length - 1, 1)
    if (arr[1] != "" && arr[1] != undefined) {
      this.countLen = arr[1].length
    }
    //this.calculationFont();
    //设置字体间距
    var worldSize = this.worldSize;
    var heightValue = this.heightValue;
    // draw 下文本有多个空格会使得和浏览器下显示不一样
    // this.innerText = this.innerText.replace(/\s+/gi, " "); //把文本多个空格转为一个空格
    this.sum = parseInt(heightValue) + parseInt(worldSize);
    this.sum_width = parseInt(heightValue);
    this.cacheLen = 120;
    this.dataCache = [];
    this.curveDlg;
    this.arrData = [];
    this.timeTwo = 0;
    this.interval = 1000;
    this.tagInfo;
    this.initSize = 0;
   // this.cons = "打印信息：";
    var tag
    if (this["animation"]["fvOutput"]) {
      tag = this["animation"]["fvOutput"]["expression"];
      if (tag.indexOf("GetVar") == -1) {
        tag = tag ? tag.replace(".PV", "") : undefined;
      }
    }
    this.getTagName = tag;
    this.getTag = new AsyncFunction("return " + tag);

    this.create();
    //调用动画
    this.initAnimation();
    if (this.isDelayedWaiting) {
      this.complete = callback;
    } else {
      callback(this);
    }
    this.createSucss();
    Object.defineProperty(this, "Text", {
        set: function (value) {
            this.innerText = value;
        },
        get: function () {
            return this.innerText;
        }
    })
    this.isHide = true;
    if(this.animation.fvHide){
        this.isHide = false;
    }
  }
  init(){
    //widthValue = this.originalSize.width * 3/2;
    //heightValue = this.originalSize.height * 3/2;
    this.width += this.borderWidth;
    this.height += this.borderWidth;
    super.init();
  }
  calculationFont(canvas) {
    var tempFont = this.font;
    this.worldSize = parseInt(tempFont.match(/\d{0,}px/g).toString().replace("px", ""));
    this.worldSize = this.worldSize == 0 ? 15 : this.worldSize;
    this.heightValue = this.worldSize;
    var arr = tempFont.split(" ");
	//arr = arr.splice(0,2);//英文盘会有下标为3的值
	
    this.initSize = PtToPx(this.worldSize);
    this.fontSize = PtToPx(this.worldSize);
    //当前字体区域宽度小于字体宽度并且x轴缩放大于y轴
    // this.fontSize = parseFloat(this.fontSize * this.magnification.x);
    // if(!this.verticalDisplay){
      //横竖文本都需要缩放
      this.fontSize = parseFloat(this.fontSize * this.magnification.x);
    // }
    //pc 获取浏览器版本非app
    if (this.getChromeVersion() && !window.isApp()) {
      var version = this.getChromeVersion();
      if (version <= 64) {
        this.deviation = Math.round((this.height / 2));
        // alert('您使用的谷歌浏览器版本过低，为了更好地体验请将浏览器升级到最新版本！');
      } else {
        this.deviation = Math.round(this.height / 2 + 1);
      }
    } else {
      this.deviation = Math.round((this.height / 2 + 1));
	}
	for(var i=0;i<arr.length;i++){
		if(arr[i].indexOf("px")>-1){
			arr[i] = this.fontSize + "px";
		}
	}
	var font = arr.join(" ");
    if(font.indexOf('System') >= 0){
      font = tempFont.replace(/System/,'宋体')
    }
    return font;
  }
  // 获取谷歌浏览器版本
  getChromeVersion() {
    var arr = navigator.userAgent.split(' ');
    var chromeVersion = '';
    for (var i = 0; i < arr.length; i++) {
      if (/chrome/i.test(arr[i]))
        chromeVersion = arr[i]
    }
    if (chromeVersion) {
      return Number(chromeVersion.split('/')[1].split('.')[0]);
    } else {
      return false;
    }
  }

  /*
        作用：垂直方向
        参数：字符，计算高度
    */
  verticallityDisplay(canvas,innerText, calculated) {
    // canvas.textBaseline='ideographic';
    //设置垂直方向top属性
    canvas.textBaseline = 'top';
    // 单个字体高度和宽度
    var textWidth = this.fontSize;
    var sx, sy, ex, ey;
    ey = sy = textWidth;
    for (var i = 0; i < innerText.length; i++) {
      if (calculated / 2 + 24 <= this.height) { //解决竖直排列超出元素高度自动隐藏字符问题
        if (this.threeDimensional == true) {
          for (var k = 0; k < 10; k++) {
            canvas.fillText(innerText[i], parseFloat(this.cx + this.width/2)-(textWidth/2) , (this.cy + this.height/2)+i * textWidth);
          }
        } else {
          canvas.textAlign = "center";
          canvas.fillText(innerText[i], parseFloat(this.cx + this.width/2), this.cy+i * textWidth);
        }
        sx = this.cx + (this.width- parseFloat(textWidth)) / 2;
        ex = sx + parseFloat(textWidth);
        if (this.underline == true) {
          canvas.beginPath();
          canvas.moveTo(sx, this.cy+sy);
          canvas.lineTo(ex, this.cy+ey);
          canvas.stroke();
          canvas.closePath();
        }
        // 字体+= 每一个字体高度和空格比例值
        ey = sy = sy += (textWidth);
      }
    }
  }
  /*
        作用：水平方向
        参数：字符，计算高度
    */
  horizontalDisplay(canvas,innerText, calculated) {
    //设置水平方向为居中
    canvas.textBaseline = 'middle';
    var sx, sy, ex, ey;
    ey = sy = this.cy +(this.height + this.initSize) / 2 - 1;
    if(this.fontSize>20){
      var zoom = 1.8;
    }else{
      var zoom = 2;
    }
    if (this.align == "left") {
      canvas.textAlign = "start";
      // if(innerText == "105-J工艺流程图"){
      //   console.log(this.cx + ":" + (this.cy + this.height/2));
      // }
      canvas.fillText(innerText, parseFloat(this.cx) , (this.cy + this.height/zoom));
      sx = this.cx + (this.width - canvas.measureText(this.innerText).width) / 2;
      ex = sx + canvas.measureText(this.innerText).width;
    } else if (this.align == "right") {
      canvas.textAlign = "right";
      canvas.fillText(innerText, parseFloat(this.cx+this.width) , (this.cy + this.height/zoom));
      sx = this.cx + (this.width - canvas.measureText(this.innerText).width) / 2;
      ex = sx + canvas.measureText(this.innerText).width;
    } else {
      canvas.fillText(innerText, parseFloat(this.cx + this.width/2) , parseFloat(this.cy + this.height/zoom));
      //用于判断 是否是 app且带有缩放字段 以及屏幕旋转90度 在计算
      // if(window.isApp() && this.system.$.embedView==1 && Math.abs(window.orientation) === 90){
      //   canvas.fillText(innerText, parseFloat(this.cx)+ this.width*this.magnification.x , (this.cy + this.height/2));
      // }
      sx = this.cx + (this.width - canvas.measureText(this.innerText).width) / 2;
      ex = sx + canvas.measureText(this.innerText).width;
    }
    if (this.threeDimensional == true) {
      //console.warn("暂不支持");
    } 
    if (this.underline == true) {
      canvas.beginPath();
      canvas.moveTo(sx, sy);
      canvas.lineTo(ex, ey);
      canvas.stroke();
      canvas.closePath();
    }
  }
  /*
   * 作用:设置单点趋势的时间间隔
   * 参数：毫秒
   */
  setInterval(t) {
    this.interval = t;
  }
  /*
      功能:缓存函数,重写父类函数
      参数:无
      返回值:无
  */
  onDraw(canvas) {
    this.setCanvas(canvas)
    if(!this.isHide) return;
    if(!this.fcHide) return;
    this.formatRect();
    canvas.save();
    this.executePreAnimation(canvas);
    this.innerText = this.innerText == undefined ? "error TagName" : this.innerText;
    var innerText = JSON.parse(JSON.stringify(this.innerText));

    if (parseFloat(this.innerText) == this.innerText) {
      if (this.indexText == 1) {
        innerText = parseFloat(innerText).toFixed(this.countLen);
      }
    }
    var resText = this.system.$.getResource(innerText)
    if (resText != undefined) {
      innerText = resText;
    }
    // 科学记数法转换
    if (this.scienceCount &&!isNaN(Number(innerText))) {
      var p = Math.floor(Math.log(innerText) / Math.LN10);
      var n = innerText * Math.pow(10, -p);
      innerText = n + 'e' + p;
    }
    canvas.font = this.calculationFont(canvas); //设置字体样式
    //判断背景是否透明
    if(this.fontSize>30){
      var zoom = 1.5;
    }else{
      var zoom = 2;
    }
    
    if (this.clarity == false) {
      canvas.fillStyle = this.borderColor; //矩形填充颜色
      var fontWidth = canvas.measureText(this.innerText).width;
      // 水平垂直都需要处理，且水平方向需要处理align
      if(this.verticalDisplay){
        var fontX = (this.cx + this.width - this.fontSize) / 2;
        var fontH = this.cy + this.fontSize * innerText.length;
        canvas.fillRect(this.cx + (this.width-this.fontSize) / 2, this.cy,this.fontSize,this.fontSize*innerText.length);
      }else{
        var fontY = (this.cy + this.height - this.fontSize) / 2;
        var fontX = (this.cx + this.width - fontWidth);
        switch(this.align){
          case 'left':
            canvas.fillRect(this.cx, (this.cy + this.height/zoom-(this.fontSize/2)), fontWidth, this.fontSize);
            break;
          case 'right':
            canvas.fillRect(this.cx+this.width-fontWidth, (this.cy + this.height/zoom-(this.fontSize/2)), fontWidth, this.fontSize);
            break;
          default:
            canvas.fillRect(this.cx+this.width/2-fontWidth/2, (this.cy + this.height/zoom-(this.fontSize/2)), fontWidth, this.fontSize);
            break;
        }
      }
    }
   
    canvas.fillStyle = this.color;
    canvas.strokeStyle = this.color;

    canvas.textAlign = "center"; //对齐格式
    // //计算高度,设置字体为微软雅黑的时候会出现文字偏差
    var calculated = this.fontSize;
    //var heightValue = this.heightValue;
    if (this.verticalDisplay) {
      this.verticallityDisplay.call(this,canvas,innerText, calculated);
    } else {
      this.horizontalDisplay.call(this,canvas,innerText, calculated);
    }
    this.Render();
    canvas.restore();
    this.executePosAnimation(canvas);
  }
  /*
      功能:创建,重写父类函数
      参数:无
      返回值:无
  */
	create() {
		if (this.isShowCurve ) {
			//调用父类前调用，当存在单点趋势或报表时执行，
			//若不存在双击脚本，增加一个空脚本，否则前端没有点击事件
			var pParent = this.parent;
			var longName = "";
			//循环获取上一级对象名称，直至倒找窗口为止
			while(pParent.type == "group"){
				longName = pParent.registerName + "." + longName;
				pParent = pParent.parentObject;
			}
			//最后把窗口名称加上
			longName = pParent.registerName + "." + longName;
			if(isApp()){
				var openViewName = this.curveAppWindow;
			}else{
				var openViewName = this.curveWindow;
			}
			if (this.animation.fvLmousescript) {
				if (!this.animation.fvLmousescript.lmousedbscript){
					if(this.isDefaultCurve){
						this.animation.fvLmousescript.lmousedbscript += ";this." + longName + this.registerName + ".$.DisplayTemplate('" + openViewName + "')";
					}else{
						this.animation.fvLmousescript.lmousedbscript += ";this." + longName + this.registerName + ".$.showExtend()";
					}
				}
			} else {
			if(this.isDefaultCurve){
				this.animation.fvLmousescript = {
				"lmousedbscript": "this." + longName + this.registerName + ".$.DisplayTemplate('" + openViewName + "')",
				"ltimer": 1000
				}
			}else{
				this.animation.fvLmousescript = {
				"lmousedbscript": "this." + longName + this.registerName + ".$.showExtend()",
				"ltimer": 1000
				}
			}
		}
	}
	super.create();
	}
	/**
	 * 作用：打开单点趋势窗口
	 */
	showExtend() {
		if (this.isShowCurve) {
			if (this["animation"]["fvOutput"]) {
				this.system.fvTextExtend.$.init(this["animation"]["fvOutput"]["expression"]);
				this.system.fvTextExtend.$.show(this, async () => {
					var value = await this.executionScript(this.getValue);
					this.system.fvTextExtend.$.newData(value);
					this.isOpen = false;
					//关闭窗口禁用定时器
					clearInterval(intervalControls);
				});
				this.isOpen = true;
				/**
				 * 作用：调用单点趋势的刷新数据
				 * 打开窗口再启动定时器，
				 */
				var intervalControls = setInterval(async () => {
					this.executionScript(this.getTag).then((res) => {
					if (res) {
						if (this.isOpen) {
						this.system.fvTextExtend.$.newData(res,this.getTagName);
						}
					}
					});
				}, this.interval);
			}
		}
	}
	async DisplayTemplate(windowName){
		var result = await this.executionScript(`return await this.Display('${windowName}','Template')`);
		if(result != true){
			var name = this.fvScript.system.$.languageName == "ch" ? ":模板窗口不存在，默认打开单点趋势！":":The template window does not exist. Single point of trend is opened by default!"
			this.system.$.$Notice.warning({
				desc: windowName + name
			});
			this.showExtend();
		}else{
			if(this.system.manager[windowName]){
				if(this.system.manager[windowName].SmartWorxRealTimeCurve){//曲线模板（原始）
					if(this.animation.fvOutput.expression){
						this.system.manager[windowName].$.setTitle("");
						var tagObj = eval(this.animation.fvOutput.expression.replace(".PV",""));
						var tagName = this.animation.fvOutput.expression.replace("__dbTags.","");
						this.system.manager[windowName].SmartWorxRealTimeCurve.$.AddData(tagName,tagObj.DESC);
						this.system.manager[windowName].SmartWorxRealTimeCurve.$.UpDateData();
					}
				}else if(this.system.manager[windowName].TrendCurve){//单点曲线
					this.system.manager[windowName].$.setTitle("");
					var tagObj = eval(this.animation.fvOutput.expression.replace(".PV",""));
					var tagName = this.animation.fvOutput.expression.replace("__dbTags.","");
					this.system.manager[windowName].TrendCurve.$.AddData(tagName,tagObj.DESC);
					this.system.manager[windowName].TrendCurve.$.UpDateData();
				}else if(this.system.manager[windowName].TrendCurveTable){//表格曲线
					this.system.manager[windowName].$.setTitle("");
					var tagObj = eval(this.animation.fvOutput.expression.replace(".PV",""));
					var tagName = this.animation.fvOutput.expression.replace("__dbTags.","");
					this.system.manager[windowName].TrendCurveTable.$.AddData(tagName,tagObj.DESC);
          this.system.manager[windowName].TrendCurveTable.$.UpDateData();
        }else if(this.system.manager[windowName].groupingCurve){//定时自定义分组
					this.system.manager[windowName].$.setTitle("");
					var tagObj = eval(this.animation.fvOutput.expression.replace(".PV",""));
					var tagName = this.animation.fvOutput.expression.replace("__dbTags.","");
					this.system.manager[windowName].groupingCurve.$.AddDataEx(tagName,tagObj.DESC,"#f00");
          this.system.manager[windowName].groupingCurve.$.UpDateData();
				}else{
					if(this.$store){
						this.system.$.$Message.error(this.$store.state.system.$.languageName == "ch" ? "添加曲线失败,窗口内部包含曲线控件或者控件名称不为 SmartWorxRealTimeCurve" : "Failed to add a curve, the window contains a curve control or the control name is not SmartWorxRealTimeCurve");
					}else{
						this.system.$.$Message.error("添加曲线失败,窗口内部包含曲线控件或者控件名称不为 SmartWorxRealTimeCurve");
					}
				}
			}else{
				this.system.$.$Message.error(this.$store.state.system.$.languageName == "ch" ? "添加曲线失败,模板未正确打开" :"Failed to add curve, template not opened correctly");
			}
	}
	}
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvTextObj.js